import { render } from "./modal.vue?vue&type=template&id=61346cf2"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=61346cf2&lang=css"
script.render = render

export default script